import { Dispatch } from 'react-redux';
import { getUserNotificationsAction } from './actions/GetUserNotificationsAction';
import { checkHasUnseenUserNotificationsAction } from './actions/CheckHasUnseenUserNotificationsAction';
import { updateUserNotificationsStatusAction } from './actions/UpdateUserNotificationStatusAction';
import { deleteUserNotificationAction } from './actions/DeleteUserNotification';
import { updateLastSeenUserNotificationAction } from './actions/UpdateLastSeenUserNotificationAction';

export class UserNotificationActions {

  constructor(private dispatch: Dispatch<unknown>) { }

  public getUserNotifications() {
    this.dispatch(getUserNotificationsAction());
  }

  public updateUserNotificationsStatus(ids: string[], readStatus: boolean) {
    this.dispatch(updateUserNotificationsStatusAction(ids, readStatus));
  }

  public deleteUserNotification(id: string) {
    this.dispatch(deleteUserNotificationAction(id));
  }

  public checkHasUnseenUserNotifications() {
    this.dispatch(checkHasUnseenUserNotificationsAction());
  }

  public updateLastSeenUserNotification(lastSeenUserNotificationId: string) {
    this.dispatch(updateLastSeenUserNotificationAction(lastSeenUserNotificationId));
  }
}
